/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createForm } from '../fn/forms/create-form';
import { CreateForm$Params } from '../fn/forms/create-form';
import { findOneForm } from '../fn/forms/find-one-form';
import { FindOneForm$Params } from '../fn/forms/find-one-form';
import { Form } from '../models/form';
import { FormQualitySubmissionDto } from '../models/form-quality-submission-dto';
import { FormUpdateStatusResponseDto } from '../models/form-update-status-response-dto';
import { listForms } from '../fn/forms/list-forms';
import { ListForms$Params } from '../fn/forms/list-forms';
import { listFormQualitySubmissions } from '../fn/forms/list-form-quality-submissions';
import { ListFormQualitySubmissions$Params } from '../fn/forms/list-form-quality-submissions';
import { submitForm } from '../fn/forms/submit-form';
import { SubmitForm$Params } from '../fn/forms/submit-form';
import { updateData } from '../fn/forms/update-data';
import { UpdateData$Params } from '../fn/forms/update-data';
import { updateStatus } from '../fn/forms/update-status';
import { UpdateStatus$Params } from '../fn/forms/update-status';

@Injectable({ providedIn: 'root' })
export class FormsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formControllerListForms()` */
  static readonly FormControllerListFormsPath = '/forms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listForms()` instead.
   *
   * This method doesn't expect any request body.
   */
  listForms$Response(params: ListForms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Form>>> {
    return listForms(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listForms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listForms(params: ListForms$Params, context?: HttpContext): Observable<Array<Form>> {
    return this.listForms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Form>>): Array<Form> => r.body)
    );
  }

  /** Path part for operation `formControllerCreateForm()` */
  static readonly FormControllerCreateFormPath = '/forms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createForm()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createForm$Response(params: CreateForm$Params, context?: HttpContext): Observable<StrictHttpResponse<Form>> {
    return createForm(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createForm$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createForm(params: CreateForm$Params, context?: HttpContext): Observable<Form> {
    return this.createForm$Response(params, context).pipe(map((r: StrictHttpResponse<Form>): Form => r.body));
  }

  /** Path part for operation `formControllerFindOneForm()` */
  static readonly FormControllerFindOneFormPath = '/forms/{formId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOneForm()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneForm$Response(params: FindOneForm$Params, context?: HttpContext): Observable<StrictHttpResponse<Form>> {
    return findOneForm(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findOneForm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneForm(params: FindOneForm$Params, context?: HttpContext): Observable<Form> {
    return this.findOneForm$Response(params, context).pipe(map((r: StrictHttpResponse<Form>): Form => r.body));
  }

  /** Path part for operation `formControllerUpdateStatus()` */
  static readonly FormControllerUpdateStatusPath = '/forms/{formId}/status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStatus$Response(
    params: UpdateStatus$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormUpdateStatusResponseDto>> {
    return updateStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStatus(params: UpdateStatus$Params, context?: HttpContext): Observable<FormUpdateStatusResponseDto> {
    return this.updateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormUpdateStatusResponseDto>): FormUpdateStatusResponseDto => r.body)
    );
  }

  /** Path part for operation `formControllerSubmitForm()` */
  static readonly FormControllerSubmitFormPath = '/forms/{formId}/submit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submitForm()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitForm$Response(params: SubmitForm$Params, context?: HttpContext): Observable<StrictHttpResponse<Form>> {
    return submitForm(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `submitForm$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitForm(params: SubmitForm$Params, context?: HttpContext): Observable<Form> {
    return this.submitForm$Response(params, context).pipe(map((r: StrictHttpResponse<Form>): Form => r.body));
  }

  /** Path part for operation `formControllerUpdateData()` */
  static readonly FormControllerUpdateDataPath = '/forms/{formId}/data';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateData$Response(params: UpdateData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateData(params: UpdateData$Params, context?: HttpContext): Observable<void> {
    return this.updateData$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `formControllerListFormQualitySubmission()` */
  static readonly FormControllerListFormQualitySubmissionsPath = '/forms/submissions/{profileId}/quality';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listFormQualitySubmissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFormQualitySubmissions$Response(
    params: ListFormQualitySubmissions$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<FormQualitySubmissionDto>>> {
    return listFormQualitySubmissions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listFormQualitySubmissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFormQualitySubmissions(
    params: ListFormQualitySubmissions$Params,
    context?: HttpContext
  ): Observable<Array<FormQualitySubmissionDto>> {
    return this.listFormQualitySubmissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormQualitySubmissionDto>>): Array<FormQualitySubmissionDto> => r.body)
    );
  }
}
